import { render, staticRenderFns } from "./ClientProfileCard.vue?vue&type=template&id=6de97649&scoped=true&"
import script from "./ClientProfileCard.vue?vue&type=script&lang=js&"
export * from "./ClientProfileCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6de97649",
  null
  
)

export default component.exports